import { render, staticRenderFns } from "./WeightUnitModal.vue?vue&type=template&id=1e90ba26"
import script from "./WeightUnitModal.vue?vue&type=script&lang=js"
export * from "./WeightUnitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports